import { useTranslation } from "react-i18next";
import Collapse from "../../../common/Collapse";

const INTRO_OUTRO_VIDEO_URL = "https://ad.advertune.com/empower-ai-videos-partner-assets/doviz/intro.mp4";

export default function OpeningSlideSettings() {
  const { t } = useTranslation();

  return (
    <Collapse
      title={
        <div className="font-semibold text-gray-800 text-xl">
          {t("intro/outro video")}
        </div>
      }
      className="mb-6"
    >
      <div className="px-4">
        <div className="w-full h-full flex items-center justify-center overflow-hidden">
          <video
            src={INTRO_OUTRO_VIDEO_URL}
            autoPlay
            muted
            loop
            className="object-contain"
            height={360}
            width={640}
          />
        </div>
      </div>
    </Collapse>
  );
}
